"use client";

import { ErrorContent } from "modules/common/components/ErrorContent";

type ErrorProps = {
  error: Error & { digest?: string };
  reset: () => void;
};

export default function ErrorComponent({ error, reset }: ErrorProps) {
  return (
    <ErrorContent
      message={error.message || "An unexpected error occurred."}
      reset={reset}
    />
  );
}
